export default __webpack_public_path__ + "static/media/logout.de0b1d20.svg";